function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 468.293 468.293",
    style: {
      enableBackground: "new 0 0 468.293 468.293"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#44C4A1"
    },
    points: "113.129,184.779 0,153.768 0,382.887 113.129,208.443  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M113.129,10.709l-87.43,21.677C11.506,35.906,0,50.265,0,64.458v41.456l113.129,31.011V10.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M442.594,8.632L296.907,41.487v222.16l22.055,6.54L468.293,43.27V28.536 C468.293,14.343,456.787,5.431,442.594,8.632z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#44C4A1"
    },
    points: "468.293,314.471 468.293,83.849 341.306,276.814  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M296.907,352.08v108.232l145.687-32.855c14.193-3.201,25.699-17.302,25.699-31.495v-33.637 l-149.042-44.198L296.907,352.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M0,423.466v8.418c0,14.193,11.506,22.846,25.699,19.327l87.43-21.677V249.023L0,423.466z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C358"
    },
    points: "113.129,136.925 0,105.914 0,153.768 113.129,184.779  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C358"
    },
    points: "113.129,208.443 0,382.887 0,423.466 113.129,249.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C358"
    },
    points: "296.907,263.647 296.907,311.501 296.907,352.08 319.251,318.126 468.293,362.325  468.293,314.471 341.306,276.814 468.293,83.849 468.293,43.27 318.962,270.187  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3EA69B"
    },
    points: "113.129,184.779 113.129,208.443 126.159,193.702  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3EA69B"
    },
    points: "151.091,162.921 263.941,35.249 113.129,10.709 113.129,136.925  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3EA69B"
    },
    points: "173.434,178.222 296.907,262.772 296.907,40.612 295.3,40.351  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3EA69B"
    },
    points: "213.269,445.828 296.907,459.437 296.907,351.205  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3EA69B"
    },
    points: "296.907,310.626 148.503,209.003 113.129,249.023 113.129,429.534 181.912,440.726  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C358"
    },
    points: "295.3,40.351 263.941,35.249 151.091,162.921 113.129,136.925 113.129,184.779  126.159,193.702 113.129,208.443 113.129,249.023 148.503,209.003 296.907,310.626 296.907,262.772 173.434,178.222  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C358"
    },
    points: "213.269,445.828 296.907,351.205 296.907,310.626 181.912,440.726  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE412D"
    },
    d: "M105.466,72.149c0,20.379-36.9,82.045-36.9,82.045c1.411,0-36.9-61.665-36.9-82.045 s16.521-36.9,36.9-36.9S105.466,51.769,105.466,72.149z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 68.564,
    cy: 72.18,
    r: 21.317
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE412D"
    },
    d: "M378.206,307.087c0,20.379-36.9,82.044-36.9,82.044c1.411,0-36.9-61.665-36.9-82.044 s16.521-36.9,36.9-36.9C361.686,270.187,378.206,286.708,378.206,307.087z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 341.292,
    cy: 307.088,
    r: 21.317
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.cb52b970.svg";
export { ForwardRef as ReactComponent };